











import { Vue, Component, Prop } from 'vue-property-decorator';

import { TeamInterface } from '@/interfaces/interfaces';
import TeamLogo from '@/components/common/team-logo/TeamLogo.vue';
import { getTeamInfo } from '@/services/TeamService';

@Component({
  components: { TeamLogo }
})
export default class FixtureTeamMobile extends Vue {
  @Prop() public team!: TeamInterface;
  @Prop() public isWinner!: boolean;
  @Prop() public score!: number;

  get teamInfo(): TeamInterface {
    return getTeamInfo(this.team);
  }
}
